import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { PlugAvatar } from '../components/PlugAvatar';
import type { OutreachLivePhase } from '../outreachTypes';
import { liveMessages as messages } from './liveMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the live screens; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Live.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The hero of "Plug is searching" (design t1): Plug, the title with the song and the scan bar. */
const SearchHeroComponent: React.FC<{ phase: OutreachLivePhase; song: string }> = ({ phase, song }) => {
  const intl = useIntl();
  const songNode = (
    <span key="song" className={styles.gradText}>
      {song}
    </span>
  );
  const title =
    phase === 'review' ? messages.reviewTitle : phase === 'writing' ? messages.writingTitle : messages.searchTitle;
  const working = phase !== 'review';
  return (
    <section className={styles.hero} data-testid="search-hero">
      <PlugAvatar size={40} state={working ? 'busy' : 'idle'} />
      <div className={styles.heroText}>
        <span className={shared.eyebrow}>
          <span className={clsx(styles.pulse, styles.pulseViolet)} aria-hidden />
          {intl.formatMessage(messages.working)}
        </span>
        <h1 className={styles.title}>{intl.formatMessage(title, { song: songNode })}</h1>
        <p>{intl.formatMessage(messages.searchBody)}</p>
        {working && (
          <div className={styles.scanbar} aria-hidden>
            <i />
          </div>
        )}
      </div>
    </section>
  );
};

export const SearchHero = TypedMemo(SearchHeroComponent);
